export default {
  debug: false,
  api: {
    version: '',
    // service: 'KYC',
    //  protocole: 'placeholder_PROTOCOL_MONEYROAD_CAPI',
    // host: 'placeholder_URL_MONEYROAD_CAPI',
    // port: 'placeholder_PORT_MONEYROAD_CAPI',
    protocole: 'placeholder_PROTOCOL_MONEYROAD_CAPI',
    host: 'placeholder_URL_MONEYROAD_CAPI',
    port: 'placeholder_PORT_MONEYROAD_CAPI',
    chemin_api: 'placeholder_API_PATH_BACKEND',
    address: function () {
      return this.protocole +
      '://' +
      this.host +
      (this.port !== '' ? ':' + this.port : '') +
      '/' +
      (this.version !== '' ? this.version + '/' : '')
    }
  },
  crypto: {
    secret: 'streammind'
  },
  language: 'fr',
  visual: 'TOOLBOX',
}
